export default { 
    categoria: {}
}